// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-row {
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: space-around;
  flex-direction: column;
  padding: 60px 20px 60px;
}
ion-row .close-icon {
  position: absolute;
  top: 10px;
  right: 10px;
  margin: 0px;
  background: var(--color-white-accent);
  width: 35px;
  height: 35px;
  padding: 0px;
  z-index: 99;
}
ion-row .close-icon ion-icon {
  width: 100%;
  height: 100%;
  margin: 0px;
}
ion-row .close-icon:hover {
  background: #f2dbd9;
}
ion-row h3,
ion-row p {
  color: #313131;
  text-transform: uppercase;
}
ion-row h3 {
  font-size: 28px;
  margin-bottom: 10px;
}
ion-row p {
  font-size: 16px;
  margin-bottom: 30px;
  font-family: AppFontLight;
}
ion-row .qr_code {
  margin: 20px 0px 30px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/loyalty-components/show-personal-promocode/show-personal-promocode.component.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,6BAAA;EACA,sBAAA;EACA,uBAAA;AACJ;AAAI;EAEI,kBAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,qCAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,WAAA;AACR;AAAQ;EACI,WAAA;EACA,YAAA;EACA,WAAA;AAEZ;AAAQ;EACI,mBAAA;AAEZ;AACI;;EAEI,cAAA;EACA,yBAAA;AACR;AACI;EACI,eAAA;EACA,mBAAA;AACR;AACI;EACI,eAAA;EACA,mBAAA;EACA,yBAAA;AACR;AAEI;EACI,qBAAA;AAAR","sourcesContent":["ion-row {\n    text-align: center;\n    display: flex;\n    align-items: center;\n    justify-content: space-around;\n    flex-direction: column;\n    padding: 60px 20px 60px;\n    .close-icon {\n\n        position: absolute;\n        top: 10px;\n        right: 10px;\n        margin: 0px;\n        background: var(--color-white-accent);\n        width: 35px;\n        height: 35px;\n        padding: 0px;\n        z-index: 99;\n        ion-icon {\n            width: 100%;\n            height: 100%;\n            margin: 0px;\n        }\n        &:hover {\n            background: #f2dbd9;\n        }\n    }\n    h3,\n    p {\n        color: #313131;\n        text-transform: uppercase;\n    }\n    h3 {\n        font-size: 28px;\n        margin-bottom: 10px;\n    }\n    p {\n        font-size: 16px;\n        margin-bottom: 30px;\n        font-family: AppFontLight;\n    }\n\n    .qr_code {\n        margin: 20px 0px 30px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
